var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-tabs i-pl-9",attrs:{"id":"customer-tabs"}},[_c('i-tabs',{attrs:{"preselected-tab":_vm.currentSelectedTab},on:{"tab-selected":_vm.onTabSelected}},_vm._l((_vm.visibleTabs),function(tab,index){return _c('i-tab',{key:index,attrs:{"slot":"tabs","label":tab.label},slot:"tabs"})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }